import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ResponsiveContext, Text, Button, Layer, Select, TextArea, Box, Anchor, RadioButtonGroup } from 'grommet';
import { FormClose } from 'grommet-icons';

import { ErrorForm, Tag } from '../../../../components';
import { TitleField, DescriptionField } from '../../../../components/form';
import { TitleDetail, Hr, SimpleDetail } from '../../../../components/detail';

import visibleWidth from '../../../../constants/layer-width';

import { createComment, toggleFormCommentLayer } from '../../actions/form-comment';
import { changeValues } from '../../../../actions/form';

import selectManifestationStatusOptions from '../../../../constants/select-manifestation-status';
import selectYesNoOptions from '../../../../constants/select-yesno-options';

class FormComment extends Component {
  handlePost = formParams => {
    const {
      createComment,
    } = this.props;

    createComment({ formParams });
  };

  render() {
    const {
      id,
      name,
      protocolNumber,
      currentStatusId,

      hasChangeStatus,
      statusId,
      comment,

      toggleLayer,
      loadingPostForm,
      postDataError,

      changeValues,
      toggleFormCommentLayer,
    } = this.props;


    if(!toggleLayer || toggleLayer !== 'createComment') {
      return null;
    }

    return (
      <ResponsiveContext.Consumer>
        {size => (
          <Layer
            responsive={false}
            full='vertical'
            position='left'
            onClickOutside={toggleFormCommentLayer}
            onEsc={toggleFormCommentLayer}
          >
            <Box
              fill='vertical'
              width={visibleWidth[size]}
              pad={{ top: 'large', bottom: 'xsmall' }}
              overflow='auto'
              flex
            >
              <Box
                direction='row'
                justify='between'
                align='baseline'
                margin={{ horizontal: 'large' }}
              >
                <TitleDetail value={'Comentar, anotar manifestação'} />

                <Button
                  plain
                  title='Fechar'
                  icon={<FormClose />}
                  onClick={toggleFormCommentLayer}
                />
              </Box>


              <Box flex overflow='auto'>
                <Box
                  gap={ size === 'small' ? 'medium' : 'small' }
                  margin={{
                    vertical: 'small',
                    horizontal: 'large',
                  }}
                  flex={{ shrink: 0 }}
                >
                  <Text color='dark-2' size='small'>
                    Anota o que falou com <u>{name}</u>, uma tentativa de ligação, mais detalhes da manifestação, etc.
                  </Text>
                </Box>


                <SimpleDetail
                  title='Protocolo'
                  value={protocolNumber}
                  description='Código gerado pelo sistema e compartilhado com o responsável pela manifestação.'
                  width={{
                    title: '50vw',
                    value: '50vw',
                  }}
                />

                <Hr />

                {/* Trocar status? */}
                <Box
                  margin={{
                    vertical: 'small',
                    horizontal: 'large'
                  }}
                  flex={{ shrink: 0 }}
                  direction={ size === 'small' ? 'column' : 'row' }
                  align='stretch'
                  gap='small'
                >
                  <Box
                    width={ size === 'small' ? '100vw' : '50vw'}
                    gap='xxsmall'
                  >
                    <TitleField text='Trocar status?' required />

                    <DescriptionField
                      text='Quero também fazer a troca do status da manifestação.'
                    />
                  </Box>

                  <Box
                    width={ size === 'small' ? '100vw' : '50vw'}
                  >
                    <Select
                      options={selectYesNoOptions}
                      value={hasChangeStatus}
                      labelKey='name'
                      valueKey={{ key: 'id', reduce: true }}
                      onChange={({ value: nextValue }) =>
                        changeValues({ fieldName: 'hasChangeStatus', value: nextValue }, 'formChangeValues')
                      }
                    />
                  </Box>
                </Box>

                {/* Status */}
                {!!hasChangeStatus && <Box
                  margin={{
                    vertical: size === 'small' ? 'medium' : 'small',
                    horizontal: 'large'
                  }}
                  flex={{ shrink: 0 }}
                  direction={ size === 'small' ? 'column' : 'row' }
                  align='stretch'
                  gap='small'
                >
                  <Box
                    width={ size === 'small' ? '100vw' : '50vw'}
                    gap='xxsmall'
                  >
                    <TitleField text='Qual será o novo status?' required />

                    <DescriptionField
                      text='Quero também fazer a troca do status da manifestação.'
                    />
                  </Box>

                  <Box
                    width={ size === 'small' ? '100vw' : '50vw'}
                    round='xxsmall'
                    pad={{
                      vertical: 'small',
                    }}
                    gap='xsmall'
                  >
                    <RadioButtonGroup
                      name='statusId'
                      value={statusId ? statusId.toString() : currentStatusId.toString()}
                      options={
                        selectManifestationStatusOptions.map(item => ({
                          label: item.name,
                          color: item.color,
                          id: item.id.toString(),
                          value: item.id.toString(),
                        }))
                      }
                      onChange={event => {
                        changeValues({ fieldName: 'statusId', value: event.target.value }, 'formChangeValues')
                      }}
                    >
                      {({ label, color }, { checked }) => {
                        let background = null;
                        let borderColor = 'dark-5';

                        if(checked) {
                          background = 'brand';
                          borderColor = 'brand';
                        }

                        return (
                          <Box
                            direction='row'
                            gap='small'
                            justify='center'
                            align='center'
                          >
                            <Box
                              width={'20px'}
                              height={'20px'}
                              background={background}
                              round='xxsmall'
                              border={{
                                color: borderColor
                              }}
                            />

                            <Tag text={label} background={color} />
                          </Box>
                        )
                      }}
                    </RadioButtonGroup>

                    <ErrorForm errorsList={postDataError.errors} fieldName='statusId' />
                  </Box>
                </Box>}

                {/* Comentário */}
                <Box
                  margin={{
                    vertical: 'small',
                    horizontal: 'large'
                  }}
                  flex={{ shrink: 0 }}
                  direction={ size === 'small' ? 'column' : 'row' }
                  align='stretch'
                  gap='small'
                >
                  <Box
                    width={ size === 'small' ? '100vw' : '50vw'}
                    gap='xxsmall'
                  >
                    <TitleField text='Comentário' required />

                    <DescriptionField
                      text='Deixe o comentário, anotação, observação...'
                    />
                  </Box>

                  <Box
                    width={ size === 'small' ? '100vw' : '50vw'}
                  >
                    <TextArea
                      rows={3}
                      resize='vertical'
                      maxLength={200}
                      value={comment ?? ''}
                      placeholder='Exemplo: Tentativa de contato'
                      onChange={event =>
                        changeValues({ fieldName: 'comment', value: event.target.value }, 'formChangeValues')
                      }
                    />

                    <ErrorForm errorsList={postDataError.errors} fieldName='comment' />
                  </Box>
                </Box>

              </Box>

              <Box
                direction='row'
                pad={{ vertical: 'medium' }}
                justify='center'
                align='center'
                gap='small'
              >
                <Box width='xsmall'>
                  <Anchor
                    color='dark-3'
                    label='Cancelar'
                    onClick={toggleFormCommentLayer}
                  />
                </Box>

                <Box width='small'>
                  <Button
                    color='brand'
                    primary
                    label={ !loadingPostForm ? 'Salvar' : 'Salvando...' }
                    disabled={ loadingPostForm }
                    onClick={() =>
                      this.handlePost({
                        id,
                        hasChangeStatus,
                        statusId,
                        comment,
                      })
                    }
                  />
                </Box>
              </Box>
            </Box>
          </Layer>
        )}
      </ResponsiveContext.Consumer>
    );
  }
}

const mapStateToProps = ({ layerReducer, formCreateUpdateCopyGeneric }) => ({
  id: formCreateUpdateCopyGeneric.id,
  name: formCreateUpdateCopyGeneric.name,
  protocolNumber: formCreateUpdateCopyGeneric.protocolNumber,
  currentStatusId: formCreateUpdateCopyGeneric.statusId,

  hasChangeStatus: formCreateUpdateCopyGeneric.hasChangeStatus || false,
  statusId: formCreateUpdateCopyGeneric.statusId || null,
  comment: formCreateUpdateCopyGeneric.comment || null,

  loadingPostForm: formCreateUpdateCopyGeneric.loadingPostForm,
  postDataError: formCreateUpdateCopyGeneric.postDataError,

  toggleLayer: layerReducer.toggleLayer,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    changeValues,
    createComment,
    toggleFormCommentLayer,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FormComment);
